const icon = "/_app/immutable/assets/icon.DGmELCLs.ico";
export {
  icon as default
};
